<template>
  <div v-if="rates && !ratingError && !reviewsError" id="customer-reviews">
    <ReviewsBlock
      :ai-summary="null"
      :ai-summary-pending="false"
      :next-reviews-cursor="reviews?.nextCursor"
      :pending-summary="ratingSummaryPending"
      :previous-reviews-cursor="reviews?.previousCursor"
      :product-id="undefined"
      :product-title="title"
      :rating="rates"
      :rating-summary
      :reviews="reviews?.results || []"
      :reviews-pending="pendingReviews"
    />
  </div>
</template>

<script setup lang="ts">
import ReviewsBlock from '~/scopes/reviews/reviews-display/components/ReviewsBlock/ReviewsBlock.vue'
import { useRatingDetailsSummary } from '~/scopes/reviews/reviews-display/composables/useRatingDetailsSummary'

import { useProductListRating } from '../../composables/useProductListRating'
import { useProductListReviews } from '../../composables/useProductListReviews'

const props = defineProps<{
  title: string
  id: string
  slug: string
}>()

const { data: rates, error: ratingError } = useProductListRating(props.id)
const {
  data: reviews,
  pending: pendingReviews,
  error: reviewsError,
} = useProductListReviews(props.id)

const { data: ratingSummary, pending: ratingSummaryPending } =
  useRatingDetailsSummary()
</script>
